import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import _ from 'lodash';

const Cell = styled.div`
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .name {
        padding: 0 10px;
        white-space: nowrap;
    }

    .side {
        width: calc(50% - 25px);
        display: flex;
        padding: 0 5px;
        align-items: center;
        justify-content: center;
    }
    .status {
        font-size: 13px;
        line-height: 18px;
        margin-bottom: 5px;
        text-align: center;
    }

    .score {
        width: 40px;
        text-align: center;
        display: inline-block;
        font-size: 20px;
    }
    .info {
        opacity: 0.7;
        font-size: 12px;
        padding-bottom: 3px;
    }
`;

const CellSmall = Cell.extend`
    width: 280px;

    margin: 5px;
    border-radius: 5px;
    background: ${props => (props.active ? `rgba(255, 0, 0, 0.1)` : `rgba(0, 0, 0, 0.3)`)};
    &:hover {
        background: rgba(255, 0, 0, 0.1);
        cursor: pointer;
    }
`;

export const Match = ({
    startDate,
    homeShortName,
    awayShortName,
    homeId,
    awayId,
    tournamentId,
    score,
    statusType,
    properties,
    onClick,
    active,
}) => (
    <CellSmall onClick={onClick} active={active}>
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px 0',
            }}
        >
            <div className="side" style={{ justifyContent: 'flex-end' }}>
                <span className="name">{homeShortName}</span>

                <img
                    alt={homeId}
                    style={{
                        width: 24,
                        height: 24,
                        minWidth: 24,
                        minHeight: 24,
                    }}
                    src={`https://dxugi372p6nmc.cloudfront.net/wdp/current/original/${homeId}/teamlogo.png`}
                />
            </div>
            {statusType === 'notstarted' && <div className="score">-:-</div>}
            {statusType !== 'notstarted' && (
                <div className="score">
                    {score.home}:{score.away}
                </div>
            )}

            <div className="side" style={{ justifyContent: 'start' }}>
                <img
                    alt={homeId}
                    style={{
                        width: 24,
                        height: 24,
                        minWidth: 24,
                        minHeight: 24,
                    }}
                    src={`https://dxugi372p6nmc.cloudfront.net/wdp/current/original/${awayId}/teamlogo.png`}
                />
                <span className="name">{awayShortName}</span>
                {/* <div className="info" style={{ fontSize: 11, textAlign: 'center' }}>
            {statusType === 'notstarted' && <div className="status">{moment(startDate).format('HH:mm')}</div>}
            {statusType === 'finished' && <div className="status">FT</div>}
            {statusType === 'inprogress' && <div className="status">LIVE</div>}
        </div> */}
            </div>
        </div>
        <div className="info">
            {!_.isNaN(+properties.round) ? 'R' + properties.round : properties.round}{' '}
            {moment(startDate).format('dd MMM')}{' '}
            {statusType === 'notstarted' && <span className="status">{moment(startDate).format('HH:mm')}</span>}
            {statusType === 'finished' && <span className="status">FT</span>}
            {statusType === 'inprogress' && <span className="status">LIVE</span>}
        </div>
    </CellSmall>
);

export const FakeCell = ({ text, onClick }) => <CellSmall onClick={onClick}>{text}</CellSmall>;

export default Match;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/components/EventCell.js
 **/